import { useTranslation } from 'react-i18next';
import { useReveal } from '@/hooks/useReveal';
import { APP_URL } from '@/config';
import { trackEvent } from '@/analytics';

export function CTA() {
  const { t } = useTranslation();
  const { ref, visible } = useReveal<HTMLDivElement>();

  return (
    <section id="join" className="relative mx-auto max-w-6xl px-5 py-24 sm:py-32">
      <div
        ref={ref}
        className={`reveal ${visible ? 'is-visible' : ''} topo relative overflow-hidden rounded-3xl border border-amber-glow/20 bg-gradient-to-br from-clay-800 to-clay-950 px-6 py-16 text-center sm:px-16`}
      >
        <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-amber-glow/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-clay-600/30 blur-3xl" />

        <h2 className="relative font-display text-3xl font-semibold tracking-tight text-clay-50 sm:text-5xl">
          {t('cta.title')}
        </h2>
        <p className="relative mx-auto mt-5 max-w-2xl text-lg text-clay-200">{t('cta.subtitle')}</p>
        <div className="relative mt-9">
          <a
            href={APP_URL}
            onClick={() => trackEvent('cta-app-click', { from: 'cta' })}
            className="btn-primary text-base"
          >
            {t('cta.button')}
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>

        <p className="relative mt-10 text-xs uppercase tracking-[0.2em] text-clay-300/60">
          {t('categories.list')}
        </p>
      </div>
    </section>
  );
}
